export default {"src":"/_next/static/media/linkedin-logo-hover.79fc9632.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};